import Vue from 'vue';
import Axios from 'axios';
import Vue2TouchEvents from 'vue2-touch-events'

import store from './store'
import i18n from './i18n'
import {mapActions, mapGetters} from "vuex"
import VueClipboard from 'vue-clipboard2'
import {getFichier} from "../api/fichier";

const searchfileComponent = () => import(
    /* webpackChunkName: "searchfile-component" */ './components/searchfileComponent'
    )
const searchComponent = () => import(
    /* webpackChunkName: "search-component" */ './components/searchComponent'
    )
const formSelectionComponent = () => import(
    /* webpackChunkName: "formSelection-component" */ './components/formSelectionComponent'
    )
const svgComponent = () => import(
    /* webpackChunkName: "svg-component" */ './components/ui/svgComponent'
    )
const loaderComponent = () => import(
    /* webpackChunkName: "loader-component" */ './components/ui/loaderComponent'
    )
const textComponent = () => import(
    /* webpackChunkName: "text-component" */ './components/form/textComponent'
    )
const universFilesComponent = () => import(
    /* webpackChunkName: "univers-component" */ './components/universFiles'
    )
const toolsComponent = () => import(
    /* webpackChunkName: "tools-component" */ './components/toolsComponent'
    )

Vue.prototype.axios = Axios
VueClipboard.config.autoSetContainer = true

Vue.use(VueClipboard)
Vue.use(Vue2TouchEvents)
Vue.filter('pluralize', (word, amount) => (amount > 1 || amount === 0) ? `${word}s` : word)

Vue.component('svgComponent',svgComponent)
Vue.component('loaderComponent',loaderComponent)
Vue.component('textComponent',textComponent)

// Prevent vue.esm pre-loading noscript tags
document.querySelectorAll('#app noscript').forEach((item) => {
    item.remove()
})

const app = new Vue({
    i18n,
    el: '#app',
    delimiters: ['${', '}'],
    components:{
        'searchfile-component': searchfileComponent,
        'search-component': searchComponent,
        'tools-component': toolsComponent,
        'formselection-component': formSelectionComponent,
        'univers-files': universFilesComponent
    },
    store,
    created () {
        this.updateSizes()
        window.addEventListener('resize', this.updateSizes)
    },
    computed: {
        ...mapGetters('grid', [
            'responsive'
        ]),
        ...mapGetters('selection', {
            selectionFichiers: 'selectionFichiers'
        })
    },
    methods: {
        ...mapActions('grid', [
            'updateSizes'
        ]),
        ...mapActions('selection', [
            'inSelection'
        ]),
        // controlsearch(flag) {
        //     this.searchFileOpen = flag
        //     this.$nextTick(() => {
        //         this.$root.$emit('controlsearch', flag)
        //     })
        // },
        updateButton(status, button) {
            status = status || false
            if (status) {
                button.classList.add('selection-contain')
                button.innerHTML = button.dataset.containLabel
            } else {
                button.classList.remove('selection-contain')
                button.innerHTML = button.dataset.uncontainLabel
            }
        },
        addFichierSelection(id, button) {
            const app = this
            window.components.front.loader(true)
            getFichier(encodeURI(id))
                .then(function (response) {
                    window.components.front.loader(false)
                    app.$store.dispatch('selection/updateSelection', response).then((status) => {
                        app.updateButton(status, button)
                    })
                })
        },
        checkSelection() {
            const self = this
            const items = document.querySelectorAll('[data-fichier-selection]')
            for (const item of items) {
                const status = self.inSelection(item.dataset.fichierSelection)
                status.then( (id) => {
                    self.updateButton(id, item)
                })
            }
        }
    },
    mounted() {
        this.$root.$el.parentNode.classList.add('app-loaded');
        let event = new Event('toolbarAppLoaded');
        window.dispatchEvent(event);
        this.checkSelection()

        if (location.search.indexOf('filename') >= 1) {
            this.$store.dispatch('openSearchFile')
        }
        // this.langselector.fr = this.$refs.linkfr.dataset.link;
        // this.langselector.en = this.$refs.linken.dataset.link;
        // this.langselector.de = this.$refs.linkde.dataset.link;
    }
})

/**
 * Bind DOM events
 */
document.addEventListener('click', function (event) {
    if (event.target.closest('a[href="#open-contact"]') || event.target.closest('[data-open-contact]')) {
        event.preventDefault();
        // self.components.front.menuActions.closeMenu()
        self.components.front.contactActions.open()
    }
    if (event.target.matches('a[href="#open-searchfile"]')) {
        event.preventDefault();
        app.$store.dispatch('openSearchFile')
    }
    if (event.target.closest('[data-fichier-selection]')) {
        event.preventDefault()
        const target = event.target.closest('[data-fichier-selection]')
        app.addFichierSelection(target.dataset.fichierSelection, target)
    }
});
